<template>
  <Layout>
    <div class="page_content d-flex flex-column">
      <div class="panel-head mb-2">
        {{ getLangValue("home.title") }}
      </div>
      <!-- 增加GTIN搜索框 -->
      <div class="my-container mb-3">
        <div class="finder active">
          <div class="finder__outer">
            <div class="finder__inner">
              <div class="finder__icon" ref="icon"></div>
              <input class="finder__input" type="text" name="q" v-model="keyword_gtin"
                :placeholder="getLangValue('home.search_gtin')" @keyup.enter="handleEnter" />
            </div>
          </div>
        </div>
      </div>
      <div class="panel-body flex-1 d-flex">
        <template v-for="(list, index) in panelList" :key="index">
          <div v-if="index == 0" :class="['card panel-card cursor', !list.disabled && 'disabled']"
            @click="handlerJump(list.router)">
            <img :src="list.icon" class="icon-company" />
          </div>
          <div v-else :class="['card panel-card cursor', !list.disabled && 'disabled']"
            @click="handlerJump(list.router)">
            <img :src="list.icon" class="card-icon" />
            <div class="card-name mt-3">{{ list.name }}</div>
          </div>
        </template>
      </div>
    </div>
  </Layout>
</template>

<script>
// 第一个Logo,国内默认用博洋的logo，英国默认用dc 的logo
// let firstIcon = require('@/assets/images/home/home-company.png')
let firstIcon = require('@/assets/images/home/dc-logo-1.png')
// if (process.env.VUE_APP_COMPANY_LOGO_CN && !JSON.parse(process.env.VUE_APP_COMPANY_LOGO_CN)) {
//   firstIcon = require('@/assets/images/home/dc-logo-1.png')
// }
// console.log('VUE_APP_COMPANY_LOGO_CN:', process.env.VUE_APP_COMPANY_LOGO_CN, typeof process.env.VUE_APP_COMPANY_LOGO_CN)
import { getFileUrl } from "@/service/index"
import { getUser_center_v3 } from "@/service/apiList/userCenter.js"
import { database_product_by_gtin } from "@/service/apiList/products.js"
import { showMessage } from "@/utils/hooks/message"
import { getLangValue } from "@/utils/common"; //获取后端语言
export default {
  data() {
    return {
      PageHeaderT: getLangValue("menu.home"),
      PageHeaderItems: [
        {
          text: getLangValue("menu.home"),
          active: true,
          href: "/homePage",
        },
      ],
      panelList: [
        {
          name: "FBD",
          icon: firstIcon,
          // router: "/garment",
          disabled: true,
        },

        {
          name: getLangValue("home.quality"),
          icon: require("@/assets/images/home/home-quality.png"),
          disabled: true,
          router: '/dashboard-quality',
        },
        {
          name: getLangValue("home.comfort"),
          icon: require("@/assets/images/home/hand_feel_002.png"),
          disabled: true,
          router: '/dashboard-comfort',
        },
        {
          name: getLangValue("home.traceability"),
          icon: require("@/assets/images/home/home-traceability.png"),
          disabled: true,
          router: '/dashboard-traceability',
        },

        {
          name: getLangValue("home.circularity"),
          icon: require("@/assets/images/home/home-return.png"),
          disabled: true,
          router: '/dashboard-circularity',
        },
        {
          name: getLangValue("home.GHG"),
          icon: require("@/assets/images/home/home-co2.png"),
          disabled: true,
          router: '/dashboard-environment',
        },
        {
          name: getLangValue("home.social"),
          icon: require("@/assets/images/home/home-env.png"),
          disabled: true,
          router: '/dashboard-esg',
        },
        {
          name: getLangValue("home.supplier"),
          icon: require("@/assets/images/home/home-supplier.png"),
          disabled: false,
        },
        {
          name: getLangValue("home.customers"),
          icon: require("@/assets/images/home/home-customer.png"),
          disabled: false,
        },
        {
          name: getLangValue("home.products"),
          icon: require("@/assets/images/home/home-product.png"),
          disabled: false,
        },
        {
          name: getLangValue("home.market"),
          icon: require("@/assets/images/home/home-market.png"),
          disabled: false,
        },
        {
          name: getLangValue("home.inventory"),
          icon: require("@/assets/images/home/home-stock.png"),
          disabled: false,
        },
      ],
      keyword_gtin: '', // GTIN搜索框的值
    };
  },
  computed: {},
  methods: {
    async handleEnter() {
      // 处理回车事件
      let keyword_gtin = this.keyword_gtin.trim();
      if (!keyword_gtin) {
        showMessage('info', getLangValue("home.input_gtin"));
        return;
      }
      // 通过gtin获取产品id 跳转到产品详情页面
      const { productId, database_id, } = await this.getProductIdByGtin(keyword_gtin);
      if (productId) {
        let url = this.$router.resolve({
          path: '/products_info', query: {
            id: productId,
            d_id: database_id,
            origin: 'productsList'
          }
        }).href
        window.open(url, '_blank')
      } else {
        showMessage('info', getLangValue("home.product_not_found"));
      }
    },
    async getProductIdByGtin(gtin) {
      // 通过gtin查询产品
      let productId = '';
      let database_id = '';
      const resp = await database_product_by_gtin(gtin);
      if (resp.code == 0) {
        if (resp.payload && resp.payload.length > 0) {
          productId = resp.payload[0]?.id; // 获取第一个产品的ID
          database_id = resp.payload[0]?.database_id; 
        } else {
          showMessage('info', getLangValue("home.product_not_found"));
        }
      }else{
        showMessage('danger', resp.message);
      }
      return { productId, database_id }; // 返回产品ID
    },
    getLangValue,
    handlerJump(router) {
      if (router) {
        this.$router.push({ path: router });
      }
    },
    async getCompanyLogo() {
      /**获取登录用户logo */
      let user_id = sessionStorage.getItem('set_menu_list') ? JSON.parse(sessionStorage.getItem('set_menu_list')).user_id : ''
      if (user_id === '' || typeof user_id == 'undefined') {
        showMessage('danger', getLangValue("base.request403"))
        this.$router.push({ path: '/login' })
      } else {
        const resp = await getUser_center_v3(user_id);
        if (resp.code == 0) {
          // console.log(resp.payload.company_logo);
          let company_logo = resp.payload.company_logo
          if (company_logo) {
            getFileUrl({ attachments: company_logo }).then(resp => {
              if (resp) {
                this.panelList[0].icon = resp.payload[0].url
              }
            })
          }
        } else {
          showMessage('danger', resp.message)
        }
      }
    },
  },

  components: {},
  created() {
    this.getCompanyLogo()
  },
};
</script>

<style scoped lang="scss">
.card {
  border-radius: 1rem !important;
}

.page_content {
  padding: 20px;
  height: calc(100vh - 70px);
  // background: url("../../assets/images/home/home-bg.jpg") no-repeat; // 背景色修改
  background-size: 100% 100%;
  overflow: auto;

  .panel-head {
    // color: #fff; // 背景色修改
    color: #212529; // 背景色修改

  }

  .panel-body {
    flex-wrap: wrap;
    justify-content: space-between;

    .panel-card {
      width: 24%;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: rgba(255, 255, 255, 0.8);

      &.disabled {
        background-color: rgba(127, 127, 127, 0.1);
        opacity: 1;
        cursor: not-allowed;
      }

      .card-name {
        text-align: center;
        color: #000;
      }
    }
  }
}

.card-icon,
.icon-company {
  width: 6rem;
  height: 6rem;
}

@media screen and(max-width: 1280px) {
  .panel-head {
    font-size: 1.8rem;
  }

  .card-icon {
    width: 4rem;
    height: 4rem;
  }

  .icon-company {
    width: 6rem;
    height: 6rem;
  }
}

@media screen and(min-width: 1440px) {
  .panel-head {
    font-size: 2rem;
  }

  .card-icon {
    width: 6rem;
    height: 6rem;
  }

  .icon-company {
    width: 8rem;
    height: 8rem;
  }
}

@media screen and(max-width: 1559px) {
  .card-name {
    font-size: 1.2rem;
  }
}

@media screen and(min-width: 1600px) {
  .card-name {
    font-size: 2rem;
  }

  .card-icon {
    width: 6rem;
    height: 6rem;
  }

  .icon-company {
    width: 10rem;
    height: 10rem;
  }
}

// 输入框

.my-container {
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}


.finder {
  width: 100%;
  // border: 1px solid #fff;
  background-color: #e7e7ec;
  border-radius: 15px;
  padding: 8px;
  // box-shadow: 4px 4px 16px rgba(189, 189, 189, 0.6), -4px -4px 16px rgba(255, 255, 255, 0.5);
}

.finder__outer {
  display: flex;
  padding: .6rem 2rem;
  border-radius: 10px;
  box-shadow: inset 10px 10px 15px -10px #c3c3c3, inset -10px -10px 15px -10px #ffffff;
}

.finder__inner {
  display: flex;
  align-items: center;
  position: relative;
  flex: 1;
}

.finder__form {
  flex: 1;
  height: calc(100% + 3rem);
}

.finder__input {
  height: calc(100% + 3rem);
  border: none;
  background-color: transparent;
  outline: none;
  font-size: 1.5rem;
  letter-spacing: 0.75px;
  flex: 1;
}

.finder__icon {
  width: 24px;
  height: 24px;
  margin-right: 1rem;
  transition: all 0.2s;
  box-shadow: inset 0 0 0 2px #313a56;
  border-radius: 50%;
  position: relative;
}

.finder__icon:before {
  display: block;
  content: "";
  position: absolute;
  transition: all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

// .finder__icon:after {
//   width: 10px;
//   height: 10px;
//   background-color: #313a56;
//   border: 3px solid #f6f5f0;
//   top: 60%;
//   position: absolute;
//   transform: translateY(-60%);
//   left: 0px;
//   right: 0;
//   margin: auto;
//   border-radius: 50%;
// }
.active .finder__icon:after {
  border-width: 10px;
  background-color: #f6f5f0;
}

.finder__icon:before {
  width: 4px;
  height: 13px;
  background-color: #f6f5f0;
  top: 40%;
  left: 20px;
  transform: rotateZ(45deg) translate(-50%, 0);
  transform-origin: 0 0;
  border-radius: 4px;
}

.active .finder__icon:before {
  background-color: #313a56;
  width: 2px;
  transform: rotateZ(40deg) translate(-200%, 25px);
}

.active .finder__icon {
  transform: translateY(-5px);
}
</style>
